import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";
import moment from "moment";

export default function DataTable_Component({ apidata, columns, searchBy }) {
  const [dataFilter, setDataFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [filters, setFilters] = useState({
    vehicle: "",
    assigned_to: "",
    status: "",
    category: "",
    pendingissue: "",
    ticket_resolved_month: "",
    ticket_issued_month: "",
  });

  // =========================================================
  // FILTER DATA
  // =========================================================
  useEffect(() => {
    let filtered = [...apidata];

    // -------------------------------------------------------
    // Search by Vehicle Number
    // -------------------------------------------------------
    if (dataFilter) {
      filtered = filtered.filter((item) =>
        item.vehicle_number?.toLowerCase().includes(dataFilter.toLowerCase()),
      );
    }

    // -------------------------------------------------------
    // Vehicle Filter
    // -------------------------------------------------------
    if (filters.vehicle) {
      filtered = filtered.filter(
        (item) => item.vehicle_number === filters.vehicle,
      );
    }

    // -------------------------------------------------------
    // Category Filter
    // -------------------------------------------------------
    if (filters.category) {
      filtered = filtered.filter(
        (item) =>
          item.category?.name?.toLowerCase() === filters.category.toLowerCase(),
      );
    }

    // -------------------------------------------------------
    // Pending Issue Filter
    // -------------------------------------------------------
    if (filters.pendingissue) {
      filtered = filtered.filter(
        (item) =>
          item.pendingissue?.toLowerCase() ===
          filters.pendingissue.toLowerCase(),
      );
    }

    // -------------------------------------------------------
    // Assigned To Filter
    // -------------------------------------------------------
    if (filters.assigned_to) {
      filtered = filtered.filter(
        (item) => item.assigned_to?.name === filters.assigned_to,
      );
    }

    // -------------------------------------------------------
    // Status Filter
    // -------------------------------------------------------
    if (filters.status) {
      filtered = filtered.filter(
        (item) => item.status?.toLowerCase() === filters.status.toLowerCase(),
      );
    }

    // -------------------------------------------------------
    // Ticket Resolved Month
    // -------------------------------------------------------
    if (filters.ticket_resolved_month) {
      filtered = filtered.filter((item) => {
        const date = item.dates?.ticket_resolved;

        if (!date) return false;

        return (
          moment.utc(date).format("YYYY-MM") === filters.ticket_resolved_month
        );
      });
    }

    // -------------------------------------------------------
    // Ticket Issued Month
    // -------------------------------------------------------
    if (filters.ticket_issued_month) {
      filtered = filtered.filter((item) => {
        const date = item.dates?.ticket_issued;

        if (!date) return false;

        return (
          moment.utc(date).format("YYYY-MM") === filters.ticket_issued_month
        );
      });
    }

    setFilteredData(filtered);
  }, [dataFilter, apidata, filters]);

  // =========================================================
  // TICKET COUNTS
  // =========================================================

  // Total tickets after search + other filters
  // We calculate this BEFORE status filtering.
  const getDataWithoutStatusFilter = () => {
    let filtered = [...apidata];

    // Search
    if (dataFilter) {
      filtered = filtered.filter((item) =>
        item.vehicle_number?.toLowerCase().includes(dataFilter.toLowerCase()),
      );
    }

    // Vehicle
    if (filters.vehicle) {
      filtered = filtered.filter(
        (item) => item.vehicle_number === filters.vehicle,
      );
    }

    // -------------------------------------------------------
    // Category
    // -------------------------------------------------------
    if (filters.category) {
      filtered = filtered.filter(
        (item) =>
          item.category?.name?.toLowerCase() === filters.category.toLowerCase(),
      );
    }

    // Assigned To
    if (filters.assigned_to) {
      filtered = filtered.filter(
        (item) => item.assigned_to?.name === filters.assigned_to,
      );
    }

    // Ticket Resolved Month
    if (filters.ticket_resolved_month) {
      filtered = filtered.filter((item) => {
        const date = item.dates?.ticket_resolved;

        if (!date) return false;

        return (
          moment.utc(date).format("YYYY-MM") === filters.ticket_resolved_month
        );
      });
    }

    // Ticket Issued Month
    if (filters.ticket_issued_month) {
      filtered = filtered.filter((item) => {
        const date = item.dates?.ticket_issued;

        if (!date) return false;

        return (
          moment.utc(date).format("YYYY-MM") === filters.ticket_issued_month
        );
      });
    }

    return filtered;
  };

  const countData = getDataWithoutStatusFilter();

  // Total
  const totalTicketCount = countData.length;

  // ToDo
  const todoCount = countData.filter(
    (item) => item.status?.toLowerCase() === "todo",
  ).length;

  // In-Progress
  const inProgressCount = countData.filter(
    (item) => item.status?.toLowerCase() === "in-progress",
  ).length;

  // Done
  const doneCount = countData.filter(
    (item) => item.status?.toLowerCase() === "done",
  ).length;

  // =========================================================
  // CLICK STATUS COUNT
  // =========================================================
  const handleStatusCountClick = (status) => {
    setFilters((prev) => ({
      ...prev,

      // If same status is clicked again,
      // remove status filter.
      status: prev.status?.toLowerCase() === status.toLowerCase() ? "" : status,
    }));
  };

  // =========================================================
  // CLICK TOTAL
  // =========================================================
  const handleTotalClick = () => {
    setFilters((prev) => ({
      ...prev,
      status: "",
    }));
  };

  // =========================================================
  // CLEAR ALL FILTERS
  // =========================================================
  const clearFilters = () => {
    setFilters({
      vehicle: "",
      assigned_to: "",
      status: "",
      category: "",
      pendingissue: "",
      ticket_resolved_month: "",
      ticket_issued_month: "",
    });

    setDataFilter("");
  };

  // =========================================================
  // CHECK IF FILTER/SEARCH IS ACTIVE
  // =========================================================
  const isFilterApplied =
    dataFilter ||
    filters.vehicle ||
    filters.assigned_to ||
    filters.status ||
    filters.category ||
    filters.pendingissue ||
    filters.ticket_resolved_month ||
    filters.ticket_issued_month;

  // =========================================================
  // ACTIVE STATUS
  // =========================================================
  const activeStatus = filters.status?.toLowerCase();

  return (
    <>
      {/* =====================================================
          SEARCH + FILTER + COUNTS
          EVERYTHING ON LEFT SIDE
      ====================================================== */}
      <div className="d-flex align-items-center mb-3 flex-wrap gap-2">
        {/* ===================================================
            SEARCH
        ==================================================== */}
        <div style={{ width: "220px" }}>
          <input
            type="text"
            placeholder="Search by Vehicle Number"
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>

        {/* ===================================================
            FILTER BUTTON
        ==================================================== */}
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => setShowFilterModal(true)}
          style={{
            height: "38px",
          }}
        >
          Filter
        </button>

        {/* ===================================================
            TOTAL TICKETS
        ==================================================== */}
        <button
          type="button"
          onClick={handleTotalClick}
          className="d-flex align-items-center px-3 rounded"
          style={{
            backgroundColor: "#e9ecef",
            border:
              activeStatus === "" ? "2px solid #6c757d" : "1px solid #ced4da",
            height: "38px",
            minWidth: "115px",
            cursor: "pointer",
            boxShadow:
              activeStatus === ""
                ? "0 0 0 2px rgba(108, 117, 125, 0.12)"
                : "none",
          }}
        >
          <span
            className="me-2"
            style={{
              width: "7px",
              height: "7px",
              borderRadius: "50%",
              backgroundColor: "#6c757d",
              display: "inline-block",
            }}
          />

          <span className="me-1">Total:</span>

          <strong>{totalTicketCount}</strong>
        </button>

        {/* ===================================================
            TODO
        ==================================================== */}
        <button
          type="button"
          onClick={() => handleStatusCountClick("Todo")}
          className="d-flex align-items-center px-3 rounded"
          style={{
            backgroundColor: "#fff3cd",
            border:
              activeStatus === "todo"
                ? "2px solid #ffc107"
                : "1px solid #ffe69c",
            height: "38px",
            minWidth: "100px",
            cursor: "pointer",
            boxShadow:
              activeStatus === "todo"
                ? "0 0 0 2px rgba(255, 193, 7, 0.12)"
                : "none",
          }}
        >
          <span
            className="me-2"
            style={{
              width: "7px",
              height: "7px",
              borderRadius: "50%",
              backgroundColor: "#ffc107",
              display: "inline-block",
            }}
          />

          <span className="me-1">ToDo:</span>

          <strong>{todoCount}</strong>
        </button>

        {/* ===================================================
            IN-PROGRESS
        ==================================================== */}
        <button
          type="button"
          onClick={() => handleStatusCountClick("In-Progress")}
          className="d-flex align-items-center px-3 rounded"
          style={{
            backgroundColor: "#cfe2ff",
            border:
              activeStatus === "in-progress"
                ? "2px solid #0d6efd"
                : "1px solid #9ec5fe",
            height: "38px",
            minWidth: "125px",
            cursor: "pointer",
            boxShadow:
              activeStatus === "in-progress"
                ? "0 0 0 2px rgba(13, 110, 253, 0.12)"
                : "none",
          }}
        >
          <span
            className="me-2"
            style={{
              width: "7px",
              height: "7px",
              borderRadius: "50%",
              backgroundColor: "#0d6efd",
              display: "inline-block",
            }}
          />

          <span className="me-1">In-Progress:</span>

          <strong>{inProgressCount}</strong>
        </button>

        {/* ===================================================
            DONE
        ==================================================== */}
        <button
          type="button"
          onClick={() => handleStatusCountClick("Done")}
          className="d-flex align-items-center px-3 rounded"
          style={{
            backgroundColor: "#d1e7dd",
            border:
              activeStatus === "done"
                ? "2px solid #198754"
                : "1px solid #a3cfbb",
            height: "38px",
            minWidth: "100px",
            cursor: "pointer",
            boxShadow:
              activeStatus === "done"
                ? "0 0 0 2px rgba(25, 135, 84, 0.12)"
                : "none",
          }}
        >
          <span
            className="me-2"
            style={{
              width: "7px",
              height: "7px",
              borderRadius: "50%",
              backgroundColor: "#198754",
              display: "inline-block",
            }}
          />

          <span className="me-1">Done:</span>

          <strong>{doneCount}</strong>
        </button>
      </div>

      {/* =====================================================
          CLEAR FILTERS
      ====================================================== */}
      {isFilterApplied && (
        <div className="mb-3">
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            onClick={clearFilters}
          >
            Clear Filters
          </button>
        </div>
      )}

      {/* =====================================================
          DATA TABLE
      ====================================================== */}
      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
        />
      ) : (
        <div className="text-center py-4 text-muted">No results found.</div>
      )}

      {/* =====================================================
          FILTER MODAL
      ====================================================== */}
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={(newFilters) => {
          setFilters(newFilters);
          setShowFilterModal(false);
        }}
        removeFilters={() => {
          setFilters({
            vehicle: "",
            assigned_to: "",
            status: "",
            pendingissue: "",
            ticket_resolved_month: "",
            ticket_issued_month: "",
          });

          setDataFilter("");
          setShowFilterModal(false);
        }}
        apidata={apidata}
      />
    </>
  );
}
